/*
 * @Author: Branton
 * @Date: 2025-10-28 17:01:49
 * @LastEditTime: 2025-10-28 17:44:38
 * @LastEditors: Branton
 * @Description:
 * @FilePath: \Rms-Tender-Frontend\src\components\cascader\index.tsx
 * 暂无
 */
import { Cascader } from 'antd';
import { forwardRef } from 'react';
// import { useTranslation } from 'react-i18next';
import './index.scss';

const ZeissCascader = (props: any, ref: any): any => {
  // const { t } = useTranslation();
  const { className, maxLength, ...rest } = props;

  return (
    <Cascader
      // options={systemCity}
      // multiple
      placeholder={''}
      className="zeiss-reset-cascader"
      maxTagCount="responsive"
      // suffixIcon={<Icon component={() => svgIcon} />}
      {...rest}
      ref={ref}
    />
  );
};

export default forwardRef(ZeissCascader);
